import { RootState } from '../store';
import { BearerboxStateModel } from './bearerboxStateModel';
import { createSelector } from '@reduxjs/toolkit';
import { initialBearerboxFetchingStatus } from './bearerboxReducer';

const selectBearerboxState = (state: RootState): BearerboxStateModel => state.bearerbox;
const selectServerId = (state: RootState, serverId: string): string => serverId;

const selectFetchingStateByServerId = createSelector(
  [selectBearerboxState, selectServerId],
  (state, serverId) => (
    state.fetchingStatus[serverId] || initialBearerboxFetchingStatus
  ),
);

export const selectIsLoadingBearerbox = createSelector(
  selectFetchingStateByServerId,
  state => state.loading,
);

export const selectErrorsForBearerbox = createSelector(
  selectFetchingStateByServerId,
  state => state.errors,
);

export const selectBearerboxByServerId = createSelector(
  [selectBearerboxState, selectServerId],
  (state, serverId) => state.entities[serverId],
);
